import request from "./request";
import axios from 'axios';
import moment from "moment";
// 登录接口
export function loginApi(data) {
    return request({
        method: "post",
        url: '/user/login',
        data
    })
}

// 获取用户睡眠日报统计数据
export function getSleepDayReport({ year, month, day }) {
    let startDate = year +'/' + month + '/' + day + ' 00:00:00';
    let endDate = year +'/' + month + '/' + day + ' 23:59:59';
    //console.log('日报起止时间', startDate, endDate)
    let startMs = moment(startDate).format('x');
    let endMs = moment(endDate).format('x');
    //console.log('日报起止时间戳',startMs, endMs)

    return request({
        method: "get",
        url: `/sleep-report-day/getSleepDayReportMs/${startMs}-${endMs}`
    })

}
// 获取用户睡眠数据比对数据
export function getSleepStatisticsDataApi({ year, month, day }) {
    return request({
        method: "get",
        url: `/statistics/sleep/${year}/${month}/${day}`
    })
}

// 获取用户睡眠周报统计数据
export function getSleepWeekReport({ year, month, week }, params = {}) {
    let currentDate = params.dayYear +'/' + params.dayMonth + '/' + params.dayDay + ' 00:00:00';
    // console.log('currentDate', currentDate)
    let startMs =  moment(currentDate).startOf('isoWeek').format('x');
    let endMs = moment(currentDate).endOf('isoWeek').format('x');
    // console.log('startMs', startMs)
    // console.log('endMs', endMs)

    return request({
        method: "get",
        url: `/sleep-report-week/getSleepWeekReportMs/${startMs}-${endMs}`
    })
}

// 获取用户睡眠月报统计数据
export function getSleepMonthReport({ year, month }) {
    let currentDate = year +'/' + month + '/' + '01' + ' 00:00:00';
    let startMs =  moment(currentDate).startOf('month').format('x');
    let endMs = moment(currentDate).endOf('month').format('x');
    return request({
        method: "get",
        url: `/sleep-report-month/getSleepMonthReportMs/${startMs}-${endMs}`
    })
}

// 判断是否是会员
export function getVipFlag() {
    return request({
        method: "get",
        url: `/user-vip/getVipFlag`
    })
}

// 查询用户信息
export function getUserInfo() {
    return request({
        method: "post",
        url: `/user/getUserInfo`
    })
}

// 查询会员信息
export function getVipInfo() {
    return request({
        method: "get",
        url: `/vip-setting/getVipInfo`
    })
}

const openBaseUrl = process.env.VUE_APP_BASE_API + '/open/query';
const settingUrl = process.env.VUE_APP_WATCH_SETTING_API;
const openTimeout = 50000;

// 获取用户睡眠日报统计数据
export function getOpenSleepDayReport({ wwid, year, month, day, vpaToken }) {
    return axios({
        method: "get",
        timeout: openTimeout,
        url: `${openBaseUrl}/day/${wwid}/${year}/${month}/${day}/${vpaToken}`
    }).then(res=> {
        if(res && res.data && res.data.success) {
            return res.data.data || []
        } else {
            return []
        }
    })
}

// 获取用户睡眠周报统计数据
export function getOpenSleepWeekReport({ wwid, year, month, week, weekYear, weekMonth, weekDay, vpaToken }) {
    return axios({
        method: "get",
        timeout: openTimeout,
        url: `${openBaseUrl}/week/${wwid}/${year}/${month}/${week}/${weekYear}/${weekMonth}/${weekDay}/${vpaToken}`,
    }).then(res=> {
        if(res && res.data && res.data.success) {
            return res.data.data || {}
        } else {
            return {}
        }
    })
}

// 获取用户睡眠月报统计数据
export function getOpenSleepMonthReport({ wwid, year, month, vpaToken }) {
    return axios({
        method: "get",
        timeout: openTimeout,
        url: `${openBaseUrl}/month/${wwid}/${year}/${month}/${vpaToken}`
    }).then(res=> {
        if(res && res.data && res.data.success) {
            return res.data.data || {}
        } else {
            return {}
        }
    })
}

// 获取手表设置信息
export function getWatchSettingInfos() {
    return axios({
        method: "get",
        timeout: 120000,
        url: '/watchApi/v1/users/setting/base',
        headers: {
            token: localStorage.getItem('token') || '',
            source: 'sleep'
        }
    }).then(res=> {
        if(res && res.data && res.data.status === "success") {
            let list = res.data.list || [];
            if(list.length) {
                let current = list.filter((item) => item.type === "temp_unit");
                return current.length && current[0].value ? current[0].value : "celsius"
            }
            else  {
                return "celsius"
            }
        } else {
            return "celsius"
        }
    }).catch(e=>{
        return "celsius"
    })

    // return request({
    //     method: "get",
    //     url: '/watchApi/v1/users/setting/base',
    //     baseURL: ''
    // })
}
// 获取手表设备信息
export function getWatchDeviceInfos({wwid, dataSourceName}) {
    return axios({
        method: "get",
        timeout: 120000,
        url: `/watchApi/v1/ticfitness/wwid/data_sources?wwid=${wwid}&dataSourceNameList=${dataSourceName}`,
    }).then(res=> {
        if(res && res.data && res.data.status === "success") {
            let list = res.data.data_sources || [];
            if(list.length) {
                let current = list.filter((item) => item.device && typeof item.device.model === 'string');
                return current.length ? current[0].device.model.toLowerCase() : "";
            }
            else  {
                return "ticwatch"
            }
        } else {
            return "ticwatch"
        }
    }).catch(e=>{
        return ""
    })
}

// 删除日报接口
export function deleteDayData(year, month, day, params) {
    //console.log(year, month, day, params)
    let startDate = year +'/' + month + '/' + day + ' 00:00:00';
    let endDate = year +'/' + month + '/' + day + ' 23:59:59';
    let startMs = moment(startDate).format('x');
    let endMs = moment(endDate).format('x');
    return request({
        method: "delete",
        url: `/sleep-report-day/deleteSleepDayReport/${startMs}-${endMs}`,
        params
    })

}


// 创建订单接口
export function createOrderApi(data) {
    return request({
        method: "post",
        url: '/user-order/createOrder',
        data
    })
}
// 获取鼾声设置信息
export function getSnoreSettingInfos() {
    return axios({
        method: "get",
        timeout: 120000,
        url: '/watchApi/v1/users/setting/base?type=snore_store',
        headers: {
            token: localStorage.getItem('token') || '',
        }
    }).then(res=> {
        if(res && res.data && res.data.status === "success") {
            let list = res.data.list || [];
            if(list.length) {
                let current = list.filter((item) => item.type === "snore_store");
                return current.length && current[0].value ?  JSON.parse(current[0].value) : {}
            }
            else  {
                return {}
            }
        } else {
            return {}
        }
    }).catch(e=>{
        return {}
    })
}
// 设置鼾声设置信息
export function setSnoreSettingInfos(data) {
    return axios({
        method: "post",
        timeout: 120000,
        url: '/watchApi/v1/users/setting/base',
        headers: {
            token: localStorage.getItem('token') || '',
        },
        data: data
    }).then(res=> {
        console.log(res)
        if(res && res.data && res.data.status === "success") {
           return true;
        } else {
            return false
        }
    }).catch(e=>{
        return false
    })
}
// 查询鼾声记录接口
export function getSnoreInfos({ year, month, day }) {
    console.log('getSnoreInfos 开始请求接口', year, month, day)
    let startDate = year +'/' + month + '/' + day + ' 00:00:00';
    let endDate = year +'/' + month + '/' + day + ' 23:59:59';
    //console.log('日报起止时间', startDate, endDate)
    let startMs = moment(startDate).format('x');
    let endMs = moment(endDate).format('x');

    return axios({
        method: "get",
        url: `/snoreApi/v1/snore/${startMs}-${endMs}`,
        headers: {
            token: localStorage.getItem('token') || '',
            'Content-Type': 'applocation/json'
        },
    }).then(res=> {
        console.log(res.data)
        if(res && res.data && res.data.status === "success" && res.data.records && res.data.records.length) {
            console.log(res.data.records)
            return res.data.records[0]

        } else {
            return {}
        }
    }).catch(e=>{
        console.log('e', e)
        return {}
    })


    // return request({
    //     method: "get",
    //     baseURL: settingUrl,
    //     url: ,
    //     headers: {
    //         token: localStorage.getItem('token') || '',
    //     },
    //     redirect: 'follow'
    // })
}

// 查询鼾声记录存储信息接口
export function getSnoreStorageInfos(params) {
    return request({
        method: "get",
        url: '/vip-setting/getVipInfo',
        params
    })
}

// 修改鼾声记录存储信息接口
export function updateSnoreStorageInfos(params) {
    return request({
        method: "post",
        url: '/vip-setting/getVipInfo',
        params
    })
}
